export const required = (message = 'Required') =>
    value => value !== undefined ? undefined : message;

export const maxLength = (max, message = 'Too Long') =>
    value => value && value.length > max ? message : undefined;

export const minLength = (min, message = 'Too short') =>
    value => value && value.length < min ? message : undefined;

export const number = (message = 'Must be a number') =>
    value => value && isNaN(Number(value)) ? message : undefined;

export const email = (message = 'Invalid Email Address') =>
    value => value && !(/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(value)) ? message : undefined;

export const zipcode = (message = 'Must be a valid zipcode') =>
    value => value && !(/^\d{6}$/.test(value)) ? message : undefined;